import { resetFilters } from "@app-redux/slices/filtersSlice";
import { resetProfileList } from "@app-redux/slices/profileListSlice";
import { resetUserData } from "@app-redux/slices/userDataSlice";
import { resetRepTop30 } from "@app-redux/slices/repTop30Slice";
import { resetOpportunity } from "@app-redux/slices/opportunitySlice";
import { useAppDispatch } from "@app-redux/store";
import { ROUTER_PATHS } from "@constants/index";
import { useMsal } from "@azure/msal-react";
import { useQueryClient } from "@tanstack/react-query";
import LogoutIcon from "@mui/icons-material/Logout";
import SettingsIcon from "@mui/icons-material/Settings";
import {
  Avatar,
  Fade,
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
} from "@mui/material";
import { stringAvatar } from "@utils/index";
import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import styles from "./styles.module.css";

export const UserMenu = ({ name, isAdmin }: { name: string; isAdmin?: boolean }) => {
  const dispatch = useAppDispatch();
  const { instance } = useMsal();
  const queryClient = useQueryClient();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleSignOut = async () => {
    queryClient.clear();
    dispatch(resetUserData());
    dispatch(resetProfileList());
    dispatch(resetFilters());
    dispatch(resetRepTop30());
    dispatch(resetOpportunity());
    await instance.logoutRedirect();
  };

  const openMenu = Boolean(anchorEl);
  return (
    <>
      <IconButton
        sx={{ p: 0 }}
        color="inherit"
        aria-label="Menu"
        onClick={(event: React.MouseEvent<HTMLElement>) =>
          setAnchorEl(event.currentTarget)
        }
        aria-controls={openMenu ? "fade-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={openMenu ? "true" : undefined}
      >
        <Avatar
          className={styles.userLogo}
          sx={{ width: 32, height: 32 }}
          {...stringAvatar(name)}
        />
      </IconButton>
      <Menu
        transformOrigin={{ horizontal: "center", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        MenuListProps={{
          "aria-labelledby": "fade-button",
        }}
        anchorEl={anchorEl}
        open={openMenu}
        onClose={() => setAnchorEl(null)}
        TransitionComponent={Fade}
      >
        <MenuItem divider className={styles.pointerNone}>
          <ListItemText className="list-header">{name}</ListItemText>
        </MenuItem>
        {isAdmin && (
          <li>
            <NavLink to={ROUTER_PATHS.appConfig}>
              {({ isActive }) => (
                <MenuItem
                  className={styles.linkMenuItem}
                  divider
                  component="div"
                  selected={isActive}
                  onClick={() => {
                    setAnchorEl(null);
                  }}
                >
                  <ListItemIcon>
                    <SettingsIcon color="inherit" />
                  </ListItemIcon>
                  <ListItemText>App Configuration</ListItemText>
                </MenuItem>
              )}
            </NavLink>
          </li>
        )}
        <MenuItem
          divider
          onClick={() => {
            handleSignOut();
            setAnchorEl(null);
          }}
        >
          <ListItemIcon>
            <LogoutIcon color="inherit" />
          </ListItemIcon>
          <ListItemText>Sign out</ListItemText>
        </MenuItem>
      </Menu>
    </>
  );
};
